
import { defineComponent, PropType, computed } from "vue";

export interface SalarySplitData {
  paid: number;
  unpaid: number;
}

export default defineComponent({
  name: "SalarySplit",
  props: {
    salaryData: {
      type: Object as PropType<SalarySplitData | null>,
      required: true
    }
  },
  setup(props) {
    const total = computed(() =>
      props.salaryData ? props.salaryData.paid + props.salaryData.unpaid : 0
    );

    const paidPercentage = computed(() =>
      props.salaryData && total.value
        ? (props.salaryData.paid / total.value) * 100
        : 0
    );

    const unpaidPercentage = computed(() =>
      props.salaryData && total.value
        ? (props.salaryData.unpaid / total.value) * 100
        : 0
    );

    const label = computed(() => {
      if (props.salaryData) {
        return `€${props.salaryData.paid} Paid ${
          props.salaryData.unpaid !== 0
            ? `/ €${props.salaryData.unpaid} Unpaid`
            : ""
        }`;
      }
      return "No data available";
    });

    return {
      unpaidPercentage,
      paidPercentage,
      label,
      total
    };
  }
});
